import { render, staticRenderFns } from "./editClinicGallery.vue?vue&type=template&id=709c0f56"
import script from "./editClinicGallery.vue?vue&type=script&lang=js"
export * from "./editClinicGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports